import { FlowDesignComponent } from './design.component';

export default FlowDesignComponent;
